module.exports = __webpack_public_path__ + "static/img/xy.153c6c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/binding/img/xy.jpg
// module id = MPeH
// module chunks = 55